<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'FindlocationMain'
}
</script>

<style></style>
